var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"re-billing-header"},[_c('h2',[_vm._v(_vm._s(_vm.appName)+"再請求・返戻データ作成")])])}
var staticRenderFns = []

export { render, staticRenderFns }